import React from "react";
import "../css/solution.info.css";
import { PUBLISHED_TXT } from "../../../utils/constants.js";
import { capitalize } from "../../../util.js";
import ReactMarkdown from "react-markdown";

const SolutionInfo = ({ activeSolutionData }) => {
  return (
    <>
      <div className="solution-info-container">
        <h3 className="solution-info-title mb-3">Solution Info</h3>
        <div className="solution-info-content">
          <div className="row solution-info-row mb-3">
            <div className="col-md-3 solution-label">Solution Name</div>
            <div className="col-md-9 solution-value">
              {activeSolutionData?.solution_name || "N/A"}
            </div>
          </div>
          <div className="row solution-info-row mb-3">
            <div className="col-md-3 solution-label">Description</div>
            <div className="col-md-9 solution-value">
              <ReactMarkdown>
                {(activeSolutionData?.description || "N/A").replace(
                  /<\/?u>/g,
                  ""
                )}
              </ReactMarkdown>
            </div>
          </div>
          <div className="row solution-info-row mb-3">
            <div className="col-md-3 solution-label">Status</div>
            <div
              className={`col-md-9 solution-value ${activeSolutionData?.approval_status?.toLowerCase() === PUBLISHED_TXT?.toLowerCase()
                ? "status-published"
                : "status-default"
                }`}
            >
              {capitalize(activeSolutionData?.approval_status) || "N/A"}
            </div>
          </div>
          <div className="row solution-info-row mb-3">
            <div className="col-md-3 solution-label">Point of Contact</div>
            <div className="col-md-9 solution-value">
              {activeSolutionData?.point_of_contact || "N/A"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SolutionInfo;
